$(document).ready(function () {
  $('.custom-description').click();
  
  $('.collection-slides').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrow:false,
    nextArrow: `
      <button type="button" class="slick-next custom-arrow">
        <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9.75739 9.39202L1.27697 17.4722C1.13547 17.6071 0.947478 17.6824 0.751985 17.6824C0.556491 17.6824 0.3685 17.6071 0.227 17.4722L0.217869 17.4631C0.149035 17.3977 0.094224 17.319 0.0567694 17.2318C0.0193148 17.1445 0 17.0506 0 16.9556C0 16.8607 0.0193148 16.7667 0.0567694 16.6795C0.094224 16.5922 0.149035 16.5135 0.217869 16.4481L8.20374 8.83964L0.217869 1.2342C0.149035 1.1688 0.094224 1.09009 0.0567694 1.00285C0.0193148 0.915606 0 0.821655 0 0.726711C0 0.631767 0.0193148 0.537817 0.0567694 0.450573C0.094224 0.363329 0.149035 0.284616 0.217869 0.219225L0.227 0.210094C0.3685 0.0752029 0.556491 -4.57764e-05 0.751985 -4.57764e-05C0.947478 -4.57764e-05 1.13547 0.0752029 1.27697 0.210094L9.75739 8.29031C9.83197 8.36137 9.89135 8.44683 9.93192 8.54152C9.97249 8.63621 9.99341 8.73815 9.99341 8.84116C9.99341 8.94418 9.97249 9.04612 9.93192 9.14081C9.89135 9.2355 9.83197 9.32096 9.75739 9.39202Z" fill="#5D6846"/>
        </svg>
      </button>
    `,

    prevArrow: `
      <button type="button" class="slick-prev custom-arrow">
        <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.236016 9.39202L8.71644 17.4722C8.85794 17.6071 9.04593 17.6824 9.24142 17.6824C9.43692 17.6824 9.62491 17.6071 9.76641 17.4722L9.77554 17.4631C9.84437 17.3977 9.89918 17.319 9.93664 17.2318C9.97409 17.1445 9.99341 17.0506 9.99341 16.9556C9.99341 16.8607 9.97409 16.7667 9.93664 16.6795C9.89918 16.5922 9.84437 16.5135 9.77554 16.4481L1.78967 8.83964L9.77554 1.2342C9.84437 1.1688 9.89918 1.09009 9.93664 1.00285C9.97409 0.915606 9.99341 0.821655 9.99341 0.726711C9.99341 0.631767 9.97409 0.537817 9.93664 0.450573C9.89918 0.363329 9.84437 0.284616 9.77554 0.219225L9.76641 0.210094C9.62491 0.0752029 9.43692 -4.57764e-05 9.24142 -4.57764e-05C9.04593 -4.57764e-05 8.85794 0.0752029 8.71644 0.210094L0.236016 8.29031C0.161434 8.36137 0.102059 8.44683 0.061489 8.54152C0.0209194 8.63621 0 8.73815 0 8.84116C0 8.94418 0.0209194 9.04612 0.061489 9.14081C0.102059 9.2355 0.161434 9.32096 0.236016 9.39202Z" fill="#5D6846"/>
        </svg>
      </button>
    `,

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

if ($(window).width() < 992) {
  $('ul.blog__posts').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrow:false,
    nextArrow: `
      <button type="button" class="slick-next custom-arrow">
        <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9.75739 9.39202L1.27697 17.4722C1.13547 17.6071 0.947478 17.6824 0.751985 17.6824C0.556491 17.6824 0.3685 17.6071 0.227 17.4722L0.217869 17.4631C0.149035 17.3977 0.094224 17.319 0.0567694 17.2318C0.0193148 17.1445 0 17.0506 0 16.9556C0 16.8607 0.0193148 16.7667 0.0567694 16.6795C0.094224 16.5922 0.149035 16.5135 0.217869 16.4481L8.20374 8.83964L0.217869 1.2342C0.149035 1.1688 0.094224 1.09009 0.0567694 1.00285C0.0193148 0.915606 0 0.821655 0 0.726711C0 0.631767 0.0193148 0.537817 0.0567694 0.450573C0.094224 0.363329 0.149035 0.284616 0.217869 0.219225L0.227 0.210094C0.3685 0.0752029 0.556491 -4.57764e-05 0.751985 -4.57764e-05C0.947478 -4.57764e-05 1.13547 0.0752029 1.27697 0.210094L9.75739 8.29031C9.83197 8.36137 9.89135 8.44683 9.93192 8.54152C9.97249 8.63621 9.99341 8.73815 9.99341 8.84116C9.99341 8.94418 9.97249 9.04612 9.93192 9.14081C9.89135 9.2355 9.83197 9.32096 9.75739 9.39202Z" fill="#5D6846"/>
        </svg>
      </button>
    `,

    prevArrow: `
      <button type="button" class="slick-prev custom-arrow">
        <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.236016 9.39202L8.71644 17.4722C8.85794 17.6071 9.04593 17.6824 9.24142 17.6824C9.43692 17.6824 9.62491 17.6071 9.76641 17.4722L9.77554 17.4631C9.84437 17.3977 9.89918 17.319 9.93664 17.2318C9.97409 17.1445 9.99341 17.0506 9.99341 16.9556C9.99341 16.8607 9.97409 16.7667 9.93664 16.6795C9.89918 16.5922 9.84437 16.5135 9.77554 16.4481L1.78967 8.83964L9.77554 1.2342C9.84437 1.1688 9.89918 1.09009 9.93664 1.00285C9.97409 0.915606 9.99341 0.821655 9.99341 0.726711C9.99341 0.631767 9.97409 0.537817 9.93664 0.450573C9.89918 0.363329 9.84437 0.284616 9.77554 0.219225L9.76641 0.210094C9.62491 0.0752029 9.43692 -4.57764e-05 9.24142 -4.57764e-05C9.04593 -4.57764e-05 8.85794 0.0752029 8.71644 0.210094L0.236016 8.29031C0.161434 8.36137 0.102059 8.44683 0.061489 8.54152C0.0209194 8.63621 0 8.73815 0 8.84116C0 8.94418 0.0209194 9.04612 0.061489 9.14081C0.102059 9.2355 0.161434 9.32096 0.236016 9.39202Z" fill="#5D6846"/>
        </svg>
      </button>
    `,

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  }

  $('.custom-home-coulmn-slides ul.multicolumn-list').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,

    nextArrow: `
      <button type="button" class="slick-next custom-arrow">
        <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9.75739 9.39202L1.27697 17.4722C1.13547 17.6071 0.947478 17.6824 0.751985 17.6824C0.556491 17.6824 0.3685 17.6071 0.227 17.4722L0.217869 17.4631C0.149035 17.3977 0.094224 17.319 0.0567694 17.2318C0.0193148 17.1445 0 17.0506 0 16.9556C0 16.8607 0.0193148 16.7667 0.0567694 16.6795C0.094224 16.5922 0.149035 16.5135 0.217869 16.4481L8.20374 8.83964L0.217869 1.2342C0.149035 1.1688 0.094224 1.09009 0.0567694 1.00285C0.0193148 0.915606 0 0.821655 0 0.726711C0 0.631767 0.0193148 0.537817 0.0567694 0.450573C0.094224 0.363329 0.149035 0.284616 0.217869 0.219225L0.227 0.210094C0.3685 0.0752029 0.556491 -4.57764e-05 0.751985 -4.57764e-05C0.947478 -4.57764e-05 1.13547 0.0752029 1.27697 0.210094L9.75739 8.29031C9.83197 8.36137 9.89135 8.44683 9.93192 8.54152C9.97249 8.63621 9.99341 8.73815 9.99341 8.84116C9.99341 8.94418 9.97249 9.04612 9.93192 9.14081C9.89135 9.2355 9.83197 9.32096 9.75739 9.39202Z" fill="#5D6846"/>
        </svg>
      </button>
    `,

    prevArrow: `
      <button type="button" class="slick-prev custom-arrow">
        <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.236016 9.39202L8.71644 17.4722C8.85794 17.6071 9.04593 17.6824 9.24142 17.6824C9.43692 17.6824 9.62491 17.6071 9.76641 17.4722L9.77554 17.4631C9.84437 17.3977 9.89918 17.319 9.93664 17.2318C9.97409 17.1445 9.99341 17.0506 9.99341 16.9556C9.99341 16.8607 9.97409 16.7667 9.93664 16.6795C9.89918 16.5922 9.84437 16.5135 9.77554 16.4481L1.78967 8.83964L9.77554 1.2342C9.84437 1.1688 9.89918 1.09009 9.93664 1.00285C9.97409 0.915606 9.99341 0.821655 9.99341 0.726711C9.99341 0.631767 9.97409 0.537817 9.93664 0.450573C9.89918 0.363329 9.84437 0.284616 9.77554 0.219225L9.76641 0.210094C9.62491 0.0752029 9.43692 -4.57764e-05 9.24142 -4.57764e-05C9.04593 -4.57764e-05 8.85794 0.0752029 8.71644 0.210094L0.236016 8.29031C0.161434 8.36137 0.102059 8.44683 0.061489 8.54152C0.0209194 8.63621 0 8.73815 0 8.84116C0 8.94418 0.0209194 9.04612 0.061489 9.14081C0.102059 9.2355 0.161434 9.32096 0.236016 9.39202Z" fill="#5D6846"/>
        </svg>
      </button>
    `,

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });


  
  $('.slides-products').slick({
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,

    nextArrow: `
      <button type="button" class="slick-next custom-arrow">
        <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9.75739 9.39202L1.27697 17.4722C1.13547 17.6071 0.947478 17.6824 0.751985 17.6824C0.556491 17.6824 0.3685 17.6071 0.227 17.4722L0.217869 17.4631C0.149035 17.3977 0.094224 17.319 0.0567694 17.2318C0.0193148 17.1445 0 17.0506 0 16.9556C0 16.8607 0.0193148 16.7667 0.0567694 16.6795C0.094224 16.5922 0.149035 16.5135 0.217869 16.4481L8.20374 8.83964L0.217869 1.2342C0.149035 1.1688 0.094224 1.09009 0.0567694 1.00285C0.0193148 0.915606 0 0.821655 0 0.726711C0 0.631767 0.0193148 0.537817 0.0567694 0.450573C0.094224 0.363329 0.149035 0.284616 0.217869 0.219225L0.227 0.210094C0.3685 0.0752029 0.556491 -4.57764e-05 0.751985 -4.57764e-05C0.947478 -4.57764e-05 1.13547 0.0752029 1.27697 0.210094L9.75739 8.29031C9.83197 8.36137 9.89135 8.44683 9.93192 8.54152C9.97249 8.63621 9.99341 8.73815 9.99341 8.84116C9.99341 8.94418 9.97249 9.04612 9.93192 9.14081C9.89135 9.2355 9.83197 9.32096 9.75739 9.39202Z" fill="#5D6846"/>
        </svg>
      </button>
    `,

    prevArrow: `
      <button type="button" class="slick-prev custom-arrow">
        <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.236016 9.39202L8.71644 17.4722C8.85794 17.6071 9.04593 17.6824 9.24142 17.6824C9.43692 17.6824 9.62491 17.6071 9.76641 17.4722L9.77554 17.4631C9.84437 17.3977 9.89918 17.319 9.93664 17.2318C9.97409 17.1445 9.99341 17.0506 9.99341 16.9556C9.99341 16.8607 9.97409 16.7667 9.93664 16.6795C9.89918 16.5922 9.84437 16.5135 9.77554 16.4481L1.78967 8.83964L9.77554 1.2342C9.84437 1.1688 9.89918 1.09009 9.93664 1.00285C9.97409 0.915606 9.99341 0.821655 9.99341 0.726711C9.99341 0.631767 9.97409 0.537817 9.93664 0.450573C9.89918 0.363329 9.84437 0.284616 9.77554 0.219225L9.76641 0.210094C9.62491 0.0752029 9.43692 -4.57764e-05 9.24142 -4.57764e-05C9.04593 -4.57764e-05 8.85794 0.0752029 8.71644 0.210094L0.236016 8.29031C0.161434 8.36137 0.102059 8.44683 0.061489 8.54152C0.0209194 8.63621 0 8.73815 0 8.84116C0 8.94418 0.0209194 9.04612 0.061489 9.14081C0.102059 9.2355 0.161434 9.32096 0.236016 9.39202Z" fill="#5D6846"/>
        </svg>
      </button>
    `,

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

jQuery(document).ready(function ($) {

  // Check if thumbnail images exist
  if ($('.thumbnail-list').length && $('.thumbnail-list .slick-slide, .thumbnail-list > *').length > 1) {

    $('.product__media-list').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: '.thumbnail-list'
    });

    $('.thumbnail-list').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      asNavFor: '.product__media-list',
      dots: true,
      centerMode: true,
      focusOnSelect: true,
      vertical: true,
      verticalSwiping: true,
      responsive: [
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            vertical: false,
            verticalSwiping: false
          }
        }
      ]
    });

  }

});



document.addEventListener('DOMContentLoaded', function () {
  const modal = document.getElementById('videoModal');
  const content = modal.querySelector('.video-modal__content');

  function getYouTubeID(url) {
    try {
      const parsedUrl = new URL(url);

      // Short URL: youtu.be/VIDEO_ID
      if (parsedUrl.hostname.includes('youtu.be')) {
        return parsedUrl.pathname.replace('/', '');
      }

      // Standard URL: youtube.com/watch?v=VIDEO_ID
      if (parsedUrl.searchParams.get('v')) {
        return parsedUrl.searchParams.get('v');
      }

      return null;
    } catch (e) {
      return null;
    }
  }

});
  
  
  $('.video-popup__grid').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 1,

    nextArrow: `
      <button type="button" class="slick-next custom-arrow">
        <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9.75739 9.39202L1.27697 17.4722C1.13547 17.6071 0.947478 17.6824 0.751985 17.6824C0.556491 17.6824 0.3685 17.6071 0.227 17.4722L0.217869 17.4631C0.149035 17.3977 0.094224 17.319 0.0567694 17.2318C0.0193148 17.1445 0 17.0506 0 16.9556C0 16.8607 0.0193148 16.7667 0.0567694 16.6795C0.094224 16.5922 0.149035 16.5135 0.217869 16.4481L8.20374 8.83964L0.217869 1.2342C0.149035 1.1688 0.094224 1.09009 0.0567694 1.00285C0.0193148 0.915606 0 0.821655 0 0.726711C0 0.631767 0.0193148 0.537817 0.0567694 0.450573C0.094224 0.363329 0.149035 0.284616 0.217869 0.219225L0.227 0.210094C0.3685 0.0752029 0.556491 -4.57764e-05 0.751985 -4.57764e-05C0.947478 -4.57764e-05 1.13547 0.0752029 1.27697 0.210094L9.75739 8.29031C9.83197 8.36137 9.89135 8.44683 9.93192 8.54152C9.97249 8.63621 9.99341 8.73815 9.99341 8.84116C9.99341 8.94418 9.97249 9.04612 9.93192 9.14081C9.89135 9.2355 9.83197 9.32096 9.75739 9.39202Z" fill="#5D6846"/>
        </svg>
      </button>
    `,

    prevArrow: `
      <button type="button" class="slick-prev custom-arrow">
        <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.236016 9.39202L8.71644 17.4722C8.85794 17.6071 9.04593 17.6824 9.24142 17.6824C9.43692 17.6824 9.62491 17.6071 9.76641 17.4722L9.77554 17.4631C9.84437 17.3977 9.89918 17.319 9.93664 17.2318C9.97409 17.1445 9.99341 17.0506 9.99341 16.9556C9.99341 16.8607 9.97409 16.7667 9.93664 16.6795C9.89918 16.5922 9.84437 16.5135 9.77554 16.4481L1.78967 8.83964L9.77554 1.2342C9.84437 1.1688 9.89918 1.09009 9.93664 1.00285C9.97409 0.915606 9.99341 0.821655 9.99341 0.726711C9.99341 0.631767 9.97409 0.537817 9.93664 0.450573C9.89918 0.363329 9.84437 0.284616 9.77554 0.219225L9.76641 0.210094C9.62491 0.0752029 9.43692 -4.57764e-05 9.24142 -4.57764e-05C9.04593 -4.57764e-05 8.85794 0.0752029 8.71644 0.210094L0.236016 8.29031C0.161434 8.36137 0.102059 8.44683 0.061489 8.54152C0.0209194 8.63621 0 8.73815 0 8.84116C0 8.94418 0.0209194 9.04612 0.061489 9.14081C0.102059 9.2355 0.161434 9.32096 0.236016 9.39202Z" fill="#5D6846"/>
        </svg>
      </button>
    `,

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
});
jQuery(document).ready(function ($) {

  // Check if current page is a collection page
  if (window.location.pathname.indexOf('/collections/') === -1) {
    return;
  }

  function moveCustomElement() {
    $('ul.product-grid li').each(function () {
      const $slide = $(this);
      const $cardInner = $slide.find('.card__inner').first();
      const $customMove = $slide.find('.custom-move').first();

      if ($cardInner.length && $customMove.length && !$customMove.parent().is($cardInner)) {
        $customMove.appendTo($cardInner);
      }
    });
  }

  // Run every 5 seconds
  setInterval(function () {
    moveCustomElement();
  }, 500);

});

$(document).ready(function () {
  $('ul.product-grid li').each(function () {
    const $slide = $(this);
    const $cardInner = $slide.find('.card__inner').first();
    const $customMove = $slide.find('.custom-move').first();

    if ($cardInner.length && $customMove.length) {
      $customMove.appendTo($cardInner);
    }
  });

  $('ul.slides-products li').each(function () {
    const $slide = $(this);

    const $cardInner = $slide.find('.card__inner').first();
    const $customMove = $slide.find('.quick-add.no-js-hidden').first();

    if ($cardInner.length && $customMove.length) {
      $customMove.appendTo($cardInner);
    }
  });

$(document).on('click', '.accordion details summary', function () {
  const $currentSummary = $(this);
  const $currentDetails = $currentSummary.closest('details');

  // Close other accordions
  $('.accordion details').not($currentDetails).each(function () {
    $(this).removeAttr('open');
    $(this).find('summary').attr('aria-expanded', 'false');
  });

  // Toggle current aria-expanded correctly
  setTimeout(function () {
    const isOpen = $currentDetails.prop('open');
    $currentSummary.attr('aria-expanded', isOpen ? 'true' : 'false');
  }, 0);
});


});



